import React from 'react';
/* Redux */
import { connect } from 'react-redux';
import {
  setOverlay,
  setUtm,
  setProductFromParams,
  setProdotto,
  setDove,
  setGiorno,
  setOrario,
  setFiliale,
  setFiliali,
  setDatiPersonali,
  saveToken,
  setCF,
  setRecap,
  setConsensi,
  setSource,
  setFaFunnerTriggered,
  setRicontattoRichiesto,
  setAccessRoute,
  setModificando
} from '../../../actions/index';
/* Components */
import Overlay from '../Overlay';
import Spinner from '../spinner';
/* Helpers */
import utils from '../../../modules/utils.js'
import { handleFaFunnel } from '../../../modules/datalayer';
import apiInvoker from "../../../modules/apiInvoker";
import { validToken, invalidToken, cloudflareToken } from "../../../modules/mocks/token";
/* Flow  */
import { handleFlow, skipScegliLuogo, skipDataAppuntamento } from '../../../flow/flow';

const mapDispatchToProps = dispatch => {
  return {
    setOverlay: (payload) => dispatch(setOverlay(payload)),
    setUtm: (utm) => dispatch(setUtm(utm)),
    setProductFromParams: (boolean) => dispatch(setProductFromParams(boolean)),
    setProdotto: (prodotto) => dispatch(setProdotto(prodotto)),
    setDove: (luogo) => dispatch(setDove(luogo)),
    setGiorno: (giorno) => dispatch(setGiorno(giorno)),
    setOrario: (orario) => dispatch(setOrario(orario)),
    setFiliale: (filiale) => dispatch(setFiliale(filiale)),
    setFiliali: (filiali) => dispatch(setFiliali(filiali)),
    setDatiPersonali: (datiPersonali) => dispatch(setDatiPersonali(datiPersonali)),
    saveToken: (token) => dispatch(saveToken(token)),
    setCF: (cf) => dispatch(setCF(cf)),
    setRecap: (recap) => dispatch(setRecap(recap)),
    setConsensi: (consensi) => dispatch(setConsensi(consensi)),
    setSource: (source) => dispatch(setSource(source)),
    setFaFunnerTriggered: (boolean) => dispatch(setFaFunnerTriggered(boolean)),
    setRicontattoRichiesto: (rr) => dispatch(setRicontattoRichiesto(rr)),
    setAccessRoute: (ar) => dispatch(setAccessRoute(ar)),
    setModificando: (m) => dispatch(setModificando(m)),
  }
}

class FlowHandler extends React.Component {
  constructor(props) {
    super(props);

    this.handleFlow = this.handleFlow.bind(this);
    this.storeUTMParameters = this.storeUTMParameters.bind(this);
    this.storeUserData = this.storeUserData.bind(this);
    this.handleEventsBoundToProduct = this.handleEventsBoundToProduct.bind(this);
    this.showFinalPage = this.showFinalPage.bind(this);
    this.retrieveTokenData = this.retrieveTokenData.bind(this);
    this.retrieveFiliale = this.retrieveFiliale.bind(this);
    this.retrieveFiliali = this.retrieveFiliali.bind(this);
  }

  componentDidMount() {
    let access_route = window.location.pathname;
    access_route = access_route.replace("fissa-appuntamento/", "");
    access_route = access_route.replace("fissa-appuntamento", "");
    this.props.setAccessRoute(access_route);
    this.handleFlow();
  }

  showFinalPage(options) {
    const self = this;
    
    const goToNextStep = function() {
      self.props.setOverlay({
        loader: {
          isVisible: false,
        }
      });
      handleFlow();
    }
    
    if (options && options.delay && !isNaN(options.delay)) {
      setTimeout(function() {
        goToNextStep();
      }, options.delay);
    } else {
      goToNextStep();
    }
  }

  storeUTMParameters() {
    const utm_source = utils.getUrlParameter("utm_source") || utils.getUrlParameter("int_source") || '';
    const utm_medium = utils.getUrlParameter("utm_medium") || utils.getUrlParameter("int_medium") || '';
    const utm_campaign = utils.getUrlParameter("utm_campaign") || utils.getUrlParameter("int_campaign") || '';
    const utm_date = utils.getUrlParameter("utm_date") || utils.getUrlParameter("int_date") || '';
    const utm_history = utils.getUrlParameter("utm_history") || utils.decodeUTMHistory(localStorage.getItem('utm_history')) || utils.getUrlParameter("int_history") || '';
    const utm_content = utils.getUrlParameter("utm_content") || utils.getUrlParameter("int_content") || '';
    const utm_term = utils.getUrlParameter("utm_term") || utils.getUrlParameter("int_term") || '';
    const mediacode = utils.getUrlParameter("mediacode") || '';

    // TODO: importare
    this.props.setUtm({
      'utm_source': utm_source,
      'utm_medium': utm_medium,
      'utm_campaign': utm_campaign,
      'utm_date': utm_date,
      'utm_history': utm_history,
      'utm_content': utm_content,
      'utm_term': utm_term,
      'mediacode': mediacode
    });
  }

  storeUserData(token, options) {
    if (token.prodotto && !isNaN(token.prodotto)) {
      this.props.setProdotto(token.prodotto);
    }
    if (token.localitaResidenza) { //Token DEM Clink
      this.props.setDove({
        'luogo': token.localitaResidenza,
      });
    }
    if (token.luogo && token.latitudine && token.longitudine) {
      this.props.setDove({
        'luogo': token.luogo,
        'coordinate_luogo': {
          'lat': token.latitudine,
          'lng': token.longitudine
        }
      });
    }
    if (token.Data) { //Token DEM Clink
      this.props.setGiorno(token.Data);
      this.props.setOrario("11:00"); //Orario impostato di default
    }
    if (token.codFiliale) { //Token DEM Clink
      this.props.setFiliale({
        'id': token.codFiliale,
        'nome': "CLINK"
      });
    }
    let impiego = utils.getUrlParameter('impiego');
    if (!impiego || impiego === '') {
      impiego = 1;
    }
    if (token.impiego) {
      impiego = token.impiego;
    }
    this.props.setDatiPersonali({
      token: token,
      nome: token.nome,
      cognome: token.cognome,
      email: token.email,
      telefono: token.telefonoCell,
      cap: token.cap,
      impiego: impiego
    });
    this.props.saveToken(token);
    this.props.setCF(token.codiceFiscale)
    this.props.setRecap(true);

    const informativa = utils.getUrlParameter('informativa');
    const dati_personali = utils.getUrlParameter('dati_personali');
    const societa_terze = utils.getUrlParameter('societa_terze');
    if (informativa || dati_personali || societa_terze) { //Ci stanno passando le informative, valorizziamo
      this.props.setConsensi({
        'informativa': informativa === "true" ? true : false,
        'dati_personali': dati_personali === "true" ? true : false,
        'societa_terze': societa_terze === "true" ? true : false
      });
    }

    //SOURCE
    const source = utils.getUrlParameter('source');
    if (source && source != "") {
      this.props.setSource(source);
    }

    this.showFinalPage(options);
  }

  handleEventsBoundToProduct(product) {
    // TODO: importare tutti i vari metodi
    this.props.setProdotto(product);

    switch (product) {
      case 1:
        handleFaFunnel('Prestito personale');
        break;
      case 3:
        handleFaFunnel('Cessione del quinto');
        // skipScegliLuogo();
        // skipDataAppuntamento();
        break;
      case 4:
        handleFaFunnel('Carta di credito');
        break;
      case 5:
        handleFaFunnel('Prestito business');
        skipScegliLuogo();
        skipDataAppuntamento();
        break;
      default:
    }

    this.props.setFaFunnerTriggered(true);
  }

  retrieveFiliali(luogo, lat, lng) {
    let self = this;
    apiInvoker.TrovaFiliali({
      "Cap": luogo,
      "Coordinate": {
        "lat": lat,
        "lng": lng
      }
    },
      res => {
        if (res.status == 200) {
          let filiali = res.data;
          const prima_filiale = filiali[0];
          self.props.setFiliali({
            'filiali': filiali,
            'filiale_selezionata': prima_filiale.idFiliale,
            'nome_filiale_selezionata': prima_filiale.nomeFiliale
          });
        }
      }, err => {
        document.querySelector('.modal-error .error-text').innerText = err;
        document.querySelector('.modal-error-container').classList.add('is-modal-shown');
      });
  }

  retrieveFiliale(idFiliale, token) {
    const self = this;
    
    apiInvoker.TrovaFiliale(idFiliale, res => {
      if (res.status == 200) {
        const coords = res.data;
        //var latlng = { lat: parseFloat(coords.lat), lng: parseFloat(coords.lng) };
        //var geocoder = new window.google.maps.Geocoder;
        let geocoder = new window.mapkit.Geocoder({
          language: "it",
          getsUserLocation: false
        });
        geocoder.reverseLookup(new window.mapkit.Coordinate(parseFloat(coords.lat), parseFloat(coords.lng)), (r_err, r_data) => {
          if (r_data && r_data.results && r_data.results.length > 0) {
            const indirizzo = r_data.results[0].formattedAddress;
            geocoder.lookup(indirizzo, function (err, data) {
              if (data && data.results && data.results.length > 0) {
                const miglior_risultato = data.results[0];
                const cap = miglior_risultato.postCode;
                self.props.setProdotto(1);
                self.props.setDove({
                  'luogo': miglior_risultato.formattedAddress,
                  'coordinate_luogo': {
                    'lat': coords.lat,
                    'lng': coords.lng
                  }
                });
                apiInvoker.TrovaFiliali({
                  "Cap": cap,
                  "Coordinate": {
                    "lat": coords.lat,
                    "lng": coords.lng
                  }
                },
                  res => {
                    if (res.status == 200) {
                      let filiali = res.data;

                      const prima_filiale = filiali[0];
                      self.props.setFiliali({
                        'filiali': filiali,
                        'filiale_selezionata': prima_filiale.idFiliale,
                        'nome_filiale_selezionata': prima_filiale.nomeFiliale
                      });
                      if (!token) {
                        self.showFinalPage();
                      }
                    }
                  }, err => {
                    document.querySelector('.modal-error .error-text').innerText = err;
                    document.querySelector('.modal-error-container').classList.add('is-modal-shown');
                  }

                );
              }
            });
          }
        });
      }
    },
    err => {
      document.querySelector('.modal-error .error-text').innerText = err;
      document.querySelector('.modal-error-container').classList.add('is-modal-shown');
    });
  }

  retrieveTokenData(token) {
    apiInvoker.CheckToken(token, res => {
      if (res.status == 200) {
        let response = res.data;

        if (response && response.codiceFiscale && response.nome) {
          token = response;
        }
      } else {
        console.error('token_data is empty');
      }

      // Inserisco delay altrimenti il flusso chatbot si blocca alla pagina "codice fiscale"
      this.storeUserData(token, { delay: 750 });
    }, err => {
      console.warn("Errore di chiamata alla decode token", err);
    });
  }

  handleFlow() {
    const token = utils.getUrlParameter('token');
    const idFiliale = utils.getUrlParameter("id_filiale");
    const nomeFiliale = utils.getUrlParameter("nome_filiale");
    const luogo = utils.getUrlParameter('luogo');
    const latitudine = utils.getUrlParameter('latitudine');
    const longitudine = utils.getUrlParameter('longitudine');
    const dataAppuntamento = utils.getUrlParameter('data_appuntamento');
    const orarioAppuntamento = utils.getUrlParameter('orario_appuntamento');
    const ricontatto = utils.getUrlParameter('ricontatto');
    let product = Number(utils.getUrlParameter("prodotto"));

    this.storeUTMParameters();

    // Se siamo su compassquinto, forziamo il flusso su "Cessione del quinto"
    if (window.document.location.hostname.indexOf("compassquinto") != -1) {
      product = 3;
    }

    if (product) {
      if (product === 3 || product === 5) {
        this.props.setProductFromParams(true);
      }

      // TODO: modificare
      this.handleEventsBoundToProduct(product);
    }

    if (luogo && latitudine && longitudine) {
      this.props.setDove({
        'luogo': luogo,
        'coordinate_luogo': {
          'lat': latitudine,
          'lng': longitudine
        }
      });
      this.retrieveFiliali(luogo, latitudine, longitudine);
    }

    if (dataAppuntamento) {
      this.props.setGiorno(dataAppuntamento);
    }

    if (orarioAppuntamento) {
      this.props.setOrario(orarioAppuntamento);
    }

    if (!idFiliale && !token) {
      this.showFinalPage();
    } else {
      if (idFiliale) {
        // Flusso custom (ci fidiamo delle informazioni passate)
        if (luogo || latitudine || longitudine || dataAppuntamento || orarioAppuntamento || nomeFiliale) {
          this.props.setFiliale({
            'id': idFiliale,
            'nome': nomeFiliale
          });
  
          if (!token) {
            this.showFinalPage();
          }
        } else {
          this.retrieveFiliale(idFiliale, token);
        }
      }

      if (ricontatto && (ricontatto == "true" || ricontatto == true || ricontatto == 1)) {
        this.props.setRicontattoRichiesto(true);
      }

      if (token) {
        let token_data = {};
  
        if (window.location.hostname === "localhost") {
          token_data = cloudflareToken;
          
          this.storeUserData(token_data);
        } else {
          this.retrieveTokenData(token)
        }
      }
    }
  }

  render() {
    return (
      <Overlay
        target="loader"
        enableBackgroundColor={true}
        render={() => <Spinner visible={true} />}
      />
    );
  }
}

export default connect(null, mapDispatchToProps)(FlowHandler);


// WEBPACK FOOTER //
// ./src/components/shared/FlowHandler/index.js